import React from "react";
import { UploadCloud, Camera, X as XIcon } from "lucide-react";

export const MultiImageUploadArea = ({
  questionId,
  files = [],
  onGalleryChange,
  onTakePhoto,
  onRemove,
  label = "Attach permit checklist photo",
  className = "mt-4",
}) => {
  const galleryInputId = `ptw-question-gallery-${questionId}`;

  return (
    <div className={className}>
      <p className="mb-1.5 text-xs font-medium text-slate-500">{label}</p>

      <div className="flex flex-wrap items-center gap-2">
        <label
          htmlFor={galleryInputId}
          className="inline-flex cursor-pointer items-center justify-center gap-1.5 rounded-lg border border-orange-200 bg-orange-50 px-3 py-2 text-xs font-semibold text-orange-700 transition-colors hover:bg-orange-100 touch-manipulation"
        >
          <UploadCloud className="h-3.5 w-3.5 shrink-0" />
          <span>Select from Gallery</span>
        </label>

        <button
          type="button"
          onClick={() => onTakePhoto?.(questionId)}
          className="inline-flex cursor-pointer items-center justify-center gap-1.5 rounded-lg bg-orange-600 px-3 py-2 text-xs font-semibold text-white transition-colors hover:bg-orange-700 touch-manipulation"
        >
          <Camera className="h-3.5 w-3.5 shrink-0" />
          <span>Take Photo</span>
        </button>

        {files.length > 0 && (
          <span className="text-xs font-medium text-slate-500">
            {files.length} photo{files.length > 1 ? "s" : ""} attached
          </span>
        )}
      </div>

      <input
        id={galleryInputId}
        type="file"
        accept="image/*"
        multiple
        className="hidden"
        onChange={(e) => {
          onGalleryChange?.(questionId, e.target.files);
          e.target.value = "";
        }}
      />

      {files.length > 0 && (
        <div className="mt-3 flex flex-wrap gap-2">
          {files.map((file, index) => {
            const previewUrl = URL.createObjectURL(file);

            return (
              <div
                key={`${file.name}-${file.lastModified}-${index}`}
                className="relative h-16 w-16 overflow-hidden rounded-lg border bg-white shadow-sm"
              >
                <img
                  src={previewUrl}
                  alt={`Permit checklist upload ${index + 1}`}
                  className="h-full w-full object-cover"
                  onLoad={() => URL.revokeObjectURL(previewUrl)}
                />

                <button
                  type="button"
                  onClick={() => onRemove?.(questionId, index)}
                  className="absolute right-0.5 top-0.5 flex h-4 w-4 items-center justify-center rounded-full bg-red-500 text-white shadow hover:bg-red-600 cursor-pointer"
                  title="Remove image"
                >
                  <XIcon className="h-2.5 w-2.5" />
                </button>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default MultiImageUploadArea;
